import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class addChargeModel extends BaseModel {
  item_text = null;
  receipt = null;
  inventory = null;
  lot = null;
  description = null;
  amount = null;
  vat = null;
  vendor_charge_uuid = null;
  taxable = false
  tax_rate = 0;
  is_grouped = false;

  attributeLabels = {
    vendor_charge_uuid: i18n.t('Select from available vendor charges'),
  };

  rules = {
    description: 'required',
    amount: 'required',
  };

  attributeHints = {}

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
